let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("do9CP")).then(() => parcelRequire('9wgg6'));